import React, { useEffect, useState, useRef } from "react";
import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { pricing, setIsPreFiltered, setPreDefinedFilter } from "../redux/slices/pricingSlice";
import { selectShapeCaratState, setSelectedCaratRange, setSelectedShape } from "../redux/slices/higherOrderSlice";
import amplitude from "../utils/ampli";

const HigherLevelGrid = ({
  accountDetails,
  queryParams,
  setQueryParams,
  isCsr,
  caratRanges,
  shapes,
  data,
  setIsChangingShapeOrCarat,
  setIsChangingGrading,
  setIsChangingPricing,
  onShapeOrCaratChange,
  
}) => {


  const dispatch = useDispatch();
  const {
    selectedShape,
    selectedCaratRange,
  } = useSelector(selectShapeCaratState);



  const handleShapeChange = (newShape) => {
      // setIsChangingShapeOrCarat(true);
      onShapeOrCaratChange();
      dispatch(setSelectedShape(newShape));
      setQueryParams((prevParams) => ({
            ...prevParams,
            shape: newShape,
      }));
      const buttonClickedEvent = {
        event_type: `v3_higher_order_shape_change_dropdown`,
        value: [newShape],
      };
      amplitude.track(buttonClickedEvent);
  };
  
  const handleCaratChange = (newCaratRange) => {
    // setIsChangingShapeOrCarat(true);
    onShapeOrCaratChange();
    dispatch(setSelectedCaratRange(newCaratRange));
    setQueryParams((prevParams) => ({
      ...prevParams,
      caratRange: newCaratRange,
      carat_range: newCaratRange,
    })); 

    const buttonClickedEvent = {
        event_type: `v3_higher_order_carat_change_dropdown`,
        value: [newCaratRange],
      };
    amplitude.track(buttonClickedEvent);
  };

  return (
    <div className="shape-carat-grid">
      {/* Shape-Carat Grid */}
      <div className=" w-max flex-col items-center mx-auto justify-center ">
        <div className="flex justify-between w-full items-center mb-3">
        
          <div className="col-sm-8" style={{paddingLeft: '0'}}>
            {/* Shape Dropdown */}
                
            <div className="flex justify-center gap-4 w-max items-center">
                  <div className="flex gap-2 justify-end">
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                     <InputLabel>Shape</InputLabel>
                      <Select
                        value={selectedShape}
                        label="Shape"
                        onChange={(e) => {
                          setIsChangingGrading(true)
                          setIsChangingPricing(true)
                          handleShapeChange(e.target.value);
                          // You might want to reset carat range or do other logic here
                          
                        }}
                      >
                        {shapes.map(shape => (
                          <MenuItem key={shape} value={shape}>
                            {data[shape].trans}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                    {/* Carat Range Dropdown */}
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                      <InputLabel>Carat Range</InputLabel>
                      <Select
                        value={selectedCaratRange}
                        label="Carat Range"
                        onChange={(e) => {
                          setIsChangingGrading(true)
                          setIsChangingPricing(true)
                        handleCaratChange(e.target.value)
                        }}
                      >
                        {caratRanges.map(range => (
                          <MenuItem key={range} value={range}>
                            {range}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HigherLevelGrid;
